import { useContext } from 'react'

import classNames from 'classnames'
import { Field, useFormikContext } from 'formik'
import { AppQuizUsageQuestionNumerical } from 'globalTypes'

import CoverImage from 'Root/App/CoverImage'
import Input from 'Root/App/Form/Input'
import PageLinkWrapper from 'Root/App/Quiz/PageLinkWrapper'
import { Context as StateContext } from 'Root/App/Quiz/StateContext'
import Title from 'Root/App/Title'
import get from 'lodash/get'
import isEqual from 'lodash/isEqual'

import FailureFeedback from '../../Feedback/Failure'
import SuccessFeedback from '../../Feedback/Success'
import styles from './index.module.css'

interface Props {
  question: AppQuizUsageQuestionNumerical
}

const Numerical = ({ question }: Props) => {
  const {
    state: { answers, content },
  } = useContext(StateContext)
  const { values, setFieldValue, setFieldTouched } = useFormikContext()
  const value = get(values, ['answers', question.id])
  const answer = get(answers, question.id)

  const hasAnswered = Boolean(value) && isEqual(answer, value)

  const hasAnsweredCorrectly =
    hasAnswered &&
    value >= question.number - (question.range || 0) &&
    value <= question.number + (question.range || 0)

  const displayValidation = content.showAnswer && hasAnswered

  const displaySuccessFeedback =
    hasAnsweredCorrectly && Boolean(question.successFeedback)
  const displayFailureFeedback =
    hasAnswered && !hasAnsweredCorrectly && Boolean(question.failureFeedback)

  const id = `answers.${question.id}`

  return (
    <div className="flex flex-col gap-y-3">
      <PageLinkWrapper slug={content.slug}>
        <Title>{question.title}</Title>
      </PageLinkWrapper>

      {Boolean(question.image) && <CoverImage imageUrl={question.image} />}

      {displaySuccessFeedback && (
        <SuccessFeedback>{question.successFeedback}</SuccessFeedback>
      )}
      {displayFailureFeedback && (
        <FailureFeedback>{question.failureFeedback}</FailureFeedback>
      )}

      <div className="flex flex-col gap-y-3">
        <Field
          as={Input}
          className={classNames({
            [styles.success]: displayValidation && hasAnsweredCorrectly,
            [styles.failure]: displayValidation && !hasAnsweredCorrectly,
          })}
          id={id}
          name={id}
          onChange={({ target }) => {
            setFieldValue(id, target.value)
            setFieldTouched(id, true)
          }}
          type="number"
        />
      </div>
    </div>
  )
}

export default Numerical
